import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check-success",
  "use": "icon-check-success-usage",
  "viewBox": "0 0 84 84",
  "content": "<symbol viewBox=\"0 0 84 84\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-success\">\n<rect width=\"84\" height=\"84\" rx=\"39.5\" fill=\"#F0FDF6\" />\n<path d=\"M42.001 21.2C53.4884 21.2 62.8006 30.5123 62.8008 41.9998C62.8008 53.4873 53.4885 62.7996 42.001 62.7996C30.5135 62.7996 21.2012 53.4873 21.2012 41.9998C21.2013 30.5123 30.5135 21.2 42.001 21.2ZM40.2549 44.1951L34.0088 36.2214L28.458 42.5144L40.085 53.071L55.5625 38.1472V38.1423L50.1855 32.0427L40.2549 44.1951Z\" fill=\"#1DCA7D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol